/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: any;
  DateTimeTz: any;
  InputValue: any;
  /** A Upload type */
  Upload: any;
};

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  children: Array<AdditionalCost>;
  id: Scalars['ID'];
  parent?: Maybe<AdditionalCost>;
  value: Scalars['String'];
};

export type AdditionalFee = {
  __typename?: 'AdditionalFee';
  amount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  single_line: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

/** Airport transfer data type */
export enum AirportTransferDataType {
  /** Arrival */
  Arrival = 'ARRIVAL',
  /** Departure */
  Departure = 'DEPARTURE'
}

export type AirportTransferInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<AirportTransferQuestion1Input>;
  question2?: InputMaybe<AirportTransferQuestion2Input>;
  question3?: InputMaybe<AirportTransferQuestion3Input>;
  question4?: InputMaybe<AirportTransferQuestion4Input>;
  question5?: InputMaybe<AirportTransferQuestion5Input>;
  slide_number: Scalars['Int'];
};

export type AirportTransferQuestion1Input = {
  arrival_transfer?: InputMaybe<Scalars['InputValue']>;
};

export type AirportTransferQuestion2Input = {
  departure_transfer?: InputMaybe<Scalars['InputValue']>;
};

export type AirportTransferQuestion3Input = {
  arrival_transfer_data?: InputMaybe<Array<ArrivalDepartureTransferDataInput>>;
};

export type AirportTransferQuestion4Input = {
  departure_transfer_data?: InputMaybe<Array<ArrivalDepartureTransferDataInput>>;
};

export type AirportTransferQuestion5Input = {
  anything_else?: InputMaybe<Scalars['InputValue']>;
};

export type AmaRecipient = {
  __typename?: 'AmaRecipient';
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type ArrivalDepartureTransferDataInput = {
  adults?: InputMaybe<Scalars['InputValue']>;
  child_ages?: InputMaybe<Scalars['InputValue']>;
  child_seats?: InputMaybe<Scalars['InputValue']>;
  children?: InputMaybe<Scalars['InputValue']>;
  date?: InputMaybe<Scalars['InputValue']>;
  flight_number?: InputMaybe<Scalars['InputValue']>;
  main_guest_name?: InputMaybe<Scalars['InputValue']>;
  main_guest_phone?: InputMaybe<Scalars['InputValue']>;
  main_guest_phone_code?: InputMaybe<Scalars['InputValue']>;
  start_time?: InputMaybe<Scalars['InputValue']>;
};

export type Availability = {
  __typename?: 'Availability';
  arrival?: Maybe<Scalars['String']>;
  available?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<CurrencyType>;
  departure?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  security_deposit?: Maybe<Scalars['Int']>;
};

export type AvailabilityInput = {
  agent_rates?: InputMaybe<Scalars['Boolean']>;
  arrival?: InputMaybe<Scalars['InputValue']>;
  booking_id?: InputMaybe<Scalars['ID']>;
  commission_percentage_override?: InputMaybe<Scalars['InputValue']>;
  departure?: InputMaybe<Scalars['InputValue']>;
  property_id?: InputMaybe<Scalars['ID']>;
};

export type BankInfoInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<BankInfoQuestion1Input>;
  question2?: InputMaybe<BankInfoQuestion2Input>;
  question3?: InputMaybe<BankInfoQuestion3Input>;
  question4?: InputMaybe<BankInfoQuestion4Input>;
  question5?: InputMaybe<BankInfoQuestion5Input>;
  slide_number: Scalars['Int'];
};

export type BankInfoQuestion1Input = {
  grade?: InputMaybe<Scalars['InputValue']>;
};

export type BankInfoQuestion2Input = {
  items_to_be_improved?: InputMaybe<Scalars['InputValue']>;
  items_to_be_improved_other?: InputMaybe<Scalars['InputValue']>;
};

export type BankInfoQuestion3Input = {
  location?: InputMaybe<Scalars['InputValue']>;
};

export type BankInfoQuestion4Input = {
  account_number?: InputMaybe<Scalars['InputValue']>;
  bank_address?: InputMaybe<Scalars['InputValue']>;
  bank_name?: InputMaybe<Scalars['InputValue']>;
  beneficiary_name?: InputMaybe<Scalars['InputValue']>;
  bic_swift_code?: InputMaybe<Scalars['InputValue']>;
  iban_code?: InputMaybe<Scalars['InputValue']>;
  routing_number?: InputMaybe<Scalars['InputValue']>;
};

export type BankInfoQuestion5Input = {
  custom_tip?: InputMaybe<Scalars['InputValue']>;
  experience?: InputMaybe<Scalars['InputValue']>;
  personal_note?: InputMaybe<Scalars['InputValue']>;
  tip?: InputMaybe<Scalars['InputValue']>;
};

export type BedroomAcType = {
  __typename?: 'BedroomAcType';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type BedroomArrangement = {
  __typename?: 'BedroomArrangement';
  bedroom_ac_type: Array<BedroomAcType>;
  bedroom_outdoor_space: Array<BedroomOutdoorSpace>;
  bedroom_toilet_access: Array<BedroomToiletAccess>;
  bedroom_type: Array<BedroomType>;
  bedroom_wash_facility: Array<BedroomWashFacility>;
  id: Scalars['ID'];
};

export type BedroomOutdoorSpace = {
  __typename?: 'BedroomOutdoorSpace';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type BedroomToiletAccess = {
  __typename?: 'BedroomToiletAccess';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type BedroomType = {
  __typename?: 'BedroomType';
  id: Scalars['ID'];
  media?: Maybe<Media>;
  value: Scalars['String'];
};

export type BedroomWashFacility = {
  __typename?: 'BedroomWashFacility';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type BoatCharterInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<BoatCharterQuestion1Input>;
  question2?: InputMaybe<BoatCharterQuestion2Input>;
  question3?: InputMaybe<BoatCharterQuestion3Input>;
  slide_number: Scalars['Int'];
  specific?: InputMaybe<Scalars['String']>;
};

export type BoatCharterQuestion1Input = {
  duration?: InputMaybe<Scalars['InputValue']>;
};

export type BoatCharterQuestion2Input = {
  adults?: InputMaybe<Scalars['InputValue']>;
  boat_type?: InputMaybe<Scalars['InputValue']>;
  budget?: InputMaybe<Scalars['InputValue']>;
  child_ages?: InputMaybe<Scalars['InputValue']>;
  children?: InputMaybe<Scalars['InputValue']>;
  end_date?: InputMaybe<Scalars['InputValue']>;
  start_date?: InputMaybe<Scalars['InputValue']>;
};

export type BoatCharterQuestion3Input = {
  anything_else?: InputMaybe<Scalars['InputValue']>;
};

export type Booking = {
  __typename?: 'Booking';
  client: User;
  concierge?: Maybe<User>;
  currency: CurrencyType;
  event: Event;
  holiday_date?: Maybe<HolidayDate>;
  id: Scalars['ID'];
  property: Property;
  temporary_concierge?: Maybe<User>;
};

/** A paginated list of Booking items. */
export type BookingPaginator = {
  __typename?: 'BookingPaginator';
  /** A list of Booking items. */
  data: Array<Booking>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BubbleBooking = {
  __typename?: 'BubbleBooking';
  id?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type BubbleContent = {
  __typename?: 'BubbleContent';
  booking?: Maybe<BubbleBooking>;
  concierge?: Maybe<Scalars['String']>;
  date_range?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  property?: Maybe<BubbleProperty>;
  service_request?: Maybe<BubbleServiceRequest>;
  service_text?: Maybe<Scalars['String']>;
  service_title?: Maybe<Scalars['String']>;
  survey_bank_info?: Maybe<BubbleSurveyBankInfo>;
  type: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
};

export type BubbleProperty = {
  __typename?: 'BubbleProperty';
  title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

export type BubbleServiceRequest = {
  __typename?: 'BubbleServiceRequest';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BubbleSurveyBankInfo = {
  __typename?: 'BubbleSurveyBankInfo';
  id?: Maybe<Scalars['String']>;
};

export type CarRentalInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<CarRentalQuestion1Input>;
  question2?: InputMaybe<CarRentalQuestion2Input>;
  question3?: InputMaybe<CarRentalQuestion3Input>;
  question4?: InputMaybe<CarRentalQuestion4Input>;
  question5?: InputMaybe<CarRentalQuestion5Input>;
  question6?: InputMaybe<CarRentalQuestion6Input>;
  question7?: InputMaybe<CarRentalQuestion7Input>;
  question8?: InputMaybe<CarRentalQuestion8Input>;
  question9?: InputMaybe<CarRentalQuestion9Input>;
  question10?: InputMaybe<CarRentalQuestion10Input>;
  slide_number: Scalars['Int'];
};

export type CarRentalQuestion1Input = {
  pick_up_drop_off?: InputMaybe<Scalars['InputValue']>;
  pick_up_drop_off_other?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion2Input = {
  start_date?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion3Input = {
  start_time?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion4Input = {
  end_date?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion5Input = {
  end_time?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion6Input = {
  car_type?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion7Input = {
  need_child_seat?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion8Input = {
  child_seats?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion9Input = {
  child_ages?: InputMaybe<Scalars['InputValue']>;
};

export type CarRentalQuestion10Input = {
  anything_else?: InputMaybe<Scalars['InputValue']>;
};

export type ChangeInquiryStatusInput = {
  status?: InputMaybe<Scalars['String']>;
};

export type CitiesFilterInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type CmsBecomeAMemberSection = {
  __typename?: 'CmsBecomeAMemberSection';
  background_image?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  heading: Scalars['String'];
};

export type CmsFeaturedPropertiesPaginator = {
  __typename?: 'CmsFeaturedPropertiesPaginator';
  data: Array<Property>;
  paginatorInfo: PaginatorInfo;
};

export type CmsGetInTouchSection = {
  __typename?: 'CmsGetInTouchSection';
  background_image?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  heading: Scalars['String'];
};

export type CmsGuestReview = {
  __typename?: 'CmsGuestReview';
  property: Property;
  review: Scalars['String'];
  reviewer: Scalars['String'];
};

export type CmsGuestReviewPaginator = {
  __typename?: 'CmsGuestReviewPaginator';
  data: Array<CmsGuestReview>;
  paginatorInfo: PaginatorInfo;
};

export type CmsPopularDestination = {
  __typename?: 'CmsPopularDestination';
  description: Scalars['String'];
  region: DestinationRegion;
};

export type CmsPopularDestinationsPaginator = {
  __typename?: 'CmsPopularDestinationsPaginator';
  data: Array<CmsPopularDestination>;
  paginatorInfo: PaginatorInfo;
};

export enum CommissionApplication {
  Eachday = 'EACHDAY',
  Once = 'ONCE'
}

export enum CommissionType {
  Currency = 'CURRENCY',
  Percentage = 'PERCENTAGE'
}

export type Contacts = {
  __typename?: 'Contacts';
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note_id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ContinentsOrderByClause = {
  column: ContinentsOrderByColumn;
  order: SortOrder;
};

export enum ContinentsOrderByColumn {
  Value = 'VALUE'
}

export type ConversationFiltersInput = {
  first?: InputMaybe<Scalars['Int']>;
  inquiry_status?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  view_as?: InputMaybe<Scalars['ID']>;
};

export type ConversationableUnion = Booking | Inquiry;

export type CountriesFilterInput = {
  continent_id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CountriesOrderByClause = {
  column: DestinationCountryOrderByColumn;
  order: SortOrder;
};

export type CreateConversationInput = {
  as_user?: InputMaybe<Scalars['ID']>;
  attachment?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  message?: InputMaybe<Scalars['InputValue']>;
  recipient?: InputMaybe<Scalars['InputValue']>;
  subject?: InputMaybe<Scalars['InputValue']>;
  template?: InputMaybe<Scalars['InputValue']>;
  type?: InputMaybe<Scalars['InputValue']>;
  type_id?: InputMaybe<Scalars['ID']>;
};

export type CreateHolidayDateInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  start_date?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type CreateMessageInput = {
  as_user?: InputMaybe<Scalars['ID']>;
  attachment?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  message?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

/** Currency type */
export enum CurrencyType {
  /** Chf */
  Chf = 'CHF',
  /** Eur */
  Eur = 'EUR',
  /** Usd */
  Usd = 'USD'
}

export type DestinationCity = {
  __typename?: 'DestinationCity';
  children: Array<DestinationCity>;
  id: Scalars['ID'];
  parent?: Maybe<DestinationCity>;
  subRegion: DestinationSubRegion;
  value: Scalars['String'];
};

/** A paginated list of DestinationCity items. */
export type DestinationCityPaginator = {
  __typename?: 'DestinationCityPaginator';
  /** A list of DestinationCity items. */
  data: Array<DestinationCity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DestinationContinent = {
  __typename?: 'DestinationContinent';
  countries: DestinationCountryPaginator;
  id: Scalars['ID'];
  property_count: Scalars['Int'];
  value: Scalars['String'];
};


export type DestinationContinentCountriesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type DestinationCountry = {
  __typename?: 'DestinationCountry';
  banner_title?: Maybe<Scalars['String']>;
  children: Array<DestinationCountry>;
  continent?: Maybe<DestinationContinent>;
  description?: Maybe<Scalars['String']>;
  get_to_know?: Maybe<DestinationGetToKnow>;
  id: Scalars['ID'];
  main_media?: Maybe<Media>;
  parent?: Maybe<DestinationCountry>;
  properties: PropertyPaginator;
  property_count: Scalars['Int'];
  random_region?: Maybe<DestinationRegion>;
  region_filters: Array<DestinationFilter>;
  regions: DestinationRegionPaginator;
  seo?: Maybe<SeoDetails>;
  slug: Scalars['String'];
  value: Scalars['String'];
};


export type DestinationCountryPropertiesArgs = {
  filters?: InputMaybe<PropertyFiltersInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<DestinationCountryPropertiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type DestinationCountryRegionsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

/** Destination country order by column */
export enum DestinationCountryOrderByColumn {
  /** Value */
  Value = 'VALUE'
}

/** A paginated list of DestinationCountry items. */
export type DestinationCountryPaginator = {
  __typename?: 'DestinationCountryPaginator';
  /** A list of DestinationCountry items. */
  data: Array<DestinationCountry>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DestinationCountryPropertiesOrderByOrderByClause = {
  column: PropertiesOrderByColumn;
  order: SortOrder;
};

export type DestinationFilter = {
  __typename?: 'DestinationFilter';
  children: Array<DestinationFilter>;
  id: Scalars['ID'];
  parent?: Maybe<DestinationFilter>;
  value: Scalars['String'];
};

/** A paginated list of DestinationFilter items. */
export type DestinationFilterPaginator = {
  __typename?: 'DestinationFilterPaginator';
  /** A list of DestinationFilter items. */
  data: Array<DestinationFilter>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DestinationGetToKnow = {
  __typename?: 'DestinationGetToKnow';
  description?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
};

export type DestinationRegion = {
  __typename?: 'DestinationRegion';
  banner_title?: Maybe<Scalars['String']>;
  children: Array<DestinationRegion>;
  country: DestinationCountry;
  description?: Maybe<Scalars['String']>;
  filters: Array<DestinationFilter>;
  get_to_know?: Maybe<DestinationGetToKnow>;
  id: Scalars['ID'];
  main_media?: Maybe<Media>;
  parent?: Maybe<DestinationRegion>;
  popularity: Scalars['Int'];
  properties: PropertyPaginator;
  property_count: Scalars['Int'];
  seo?: Maybe<SeoDetails>;
  slug: Scalars['String'];
  subRegions: Array<DestinationSubRegion>;
  value: Scalars['String'];
};


export type DestinationRegionFiltersArgs = {
  parent_id?: InputMaybe<Scalars['ID']>;
};


export type DestinationRegionPropertiesArgs = {
  filters?: InputMaybe<PropertyFiltersInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<DestinationRegionPropertiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};

/** Destination region order by column */
export enum DestinationRegionOrderByColumn {
  /** Popularity */
  Popularity = 'POPULARITY',
  /** Value */
  Value = 'VALUE'
}

export type DestinationRegionOrderByOrderByClause = {
  column: DestinationRegionOrderByColumn;
  order: SortOrder;
};

/** A paginated list of DestinationRegion items. */
export type DestinationRegionPaginator = {
  __typename?: 'DestinationRegionPaginator';
  /** A list of DestinationRegion items. */
  data: Array<DestinationRegion>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DestinationRegionPropertiesOrderByOrderByClause = {
  column: PropertiesOrderByColumn;
  order: SortOrder;
};

export type DestinationSubRegion = {
  __typename?: 'DestinationSubRegion';
  banner_title?: Maybe<Scalars['String']>;
  children: Array<DestinationSubRegion>;
  description?: Maybe<Scalars['String']>;
  display_text: Scalars['String'];
  get_to_know?: Maybe<DestinationGetToKnow>;
  id: Scalars['ID'];
  main_media?: Maybe<Media>;
  parent?: Maybe<DestinationSubRegion>;
  properties: PropertyPaginator;
  region: DestinationRegion;
  seo?: Maybe<SeoDetails>;
  slug: Scalars['String'];
  value: Scalars['String'];
};


export type DestinationSubRegionPropertiesArgs = {
  filters?: InputMaybe<PropertyFiltersInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<DestinationSubRegionPropertiesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};

/** A paginated list of DestinationSubRegion items. */
export type DestinationSubRegionPaginator = {
  __typename?: 'DestinationSubRegionPaginator';
  /** A list of DestinationSubRegion items. */
  data: Array<DestinationSubRegion>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type DestinationSubRegionPropertiesOrderByOrderByClause = {
  column: PropertiesOrderByColumn;
  order: SortOrder;
};

/** Discount type */
export enum DiscountType {
  /** Agent */
  Agent = 'AGENT',
  /** Ama */
  Ama = 'AMA',
  /** Rental */
  Rental = 'RENTAL'
}

export type DownloadPdfType = {
  __typename?: 'DownloadPdfType';
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Duration type */
export enum DurationType {
  /** Day */
  Day = 'DAY',
  /** Multi day */
  MultiDay = 'MULTI_DAY'
}

export type EndOutOfOfficeModeInput = {
  booking_id?: InputMaybe<Scalars['ID']>;
  replace_booking_concierge?: InputMaybe<Scalars['Boolean']>;
};

export type EntertainmentAmenity = {
  __typename?: 'EntertainmentAmenity';
  children: Array<EntertainmentAmenity>;
  id: Scalars['ID'];
  parent?: Maybe<EntertainmentAmenity>;
  value: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  end_date: Scalars['DateTime'];
  id: Scalars['ID'];
  property: Property;
  start_date: Scalars['DateTime'];
};

export type ExternalPropertiesInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type ExternalProperty = {
  __typename?: 'ExternalProperty';
  image: Scalars['String'];
  property?: Maybe<Property>;
  provider: Scalars['String'];
  providerId: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** A paginated list of ExternalProperty items. */
export type ExternalPropertyPaginator = {
  __typename?: 'ExternalPropertyPaginator';
  /** A list of ExternalProperty items. */
  data: Array<ExternalProperty>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type FormattedContent = BubbleContent | MessageContent;

export type GeneralAmenity = {
  __typename?: 'GeneralAmenity';
  children: Array<GeneralAmenity>;
  id: Scalars['ID'];
  parent?: Maybe<GeneralAmenity>;
  value: Scalars['String'];
};

export type GeneralService = {
  __typename?: 'GeneralService';
  category?: Maybe<GeneralServiceCategory>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  form_link?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image_alt_text?: Maybe<Scalars['String']>;
  images: Array<Media>;
  is_featured: Scalars['Boolean'];
  nearby_services: Array<GeneralService>;
  page_description?: Maybe<Scalars['String']>;
  popularity: Scalars['Int'];
  regions: Array<DestinationRegion>;
  seo_description?: Maybe<Scalars['String']>;
  seo_title?: Maybe<Scalars['String']>;
  service_details?: Maybe<Scalars['String']>;
  service_filters?: Maybe<Array<Maybe<GeneralServiceFilter>>>;
  service_image?: Maybe<Media>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sub_category?: Maybe<GeneralServiceSubCategory>;
  subtitle?: Maybe<Scalars['String']>;
  survey_slug?: Maybe<Scalars['String']>;
  templates?: Maybe<Array<Maybe<GeneralServiceTemplate>>>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

export type GeneralServiceCategory = {
  __typename?: 'GeneralServiceCategory';
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** A paginated list of GeneralServiceCategory items. */
export type GeneralServiceCategoryPaginator = {
  __typename?: 'GeneralServiceCategoryPaginator';
  /** A list of GeneralServiceCategory items. */
  data: Array<GeneralServiceCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GeneralServiceFilter = {
  __typename?: 'GeneralServiceFilter';
  children: Array<GeneralServiceFilter>;
  id: Scalars['ID'];
  parent?: Maybe<GeneralServiceFilter>;
  parent_id?: Maybe<Scalars['ID']>;
  value: Scalars['String'];
};

/** A paginated list of GeneralServiceFilter items. */
export type GeneralServiceFilterPaginator = {
  __typename?: 'GeneralServiceFilterPaginator';
  /** A list of GeneralServiceFilter items. */
  data: Array<GeneralServiceFilter>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum GeneralServiceOrderByClause {
  Popularity = 'POPULARITY',
  Random = 'RANDOM'
}

export type GeneralServiceOrderByOrderByClause = {
  column: GeneralServiceOrderByClause;
  order: SortOrder;
};

/** A paginated list of GeneralService items. */
export type GeneralServicePaginator = {
  __typename?: 'GeneralServicePaginator';
  /** A list of GeneralService items. */
  data: Array<GeneralService>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GeneralServiceSubCategory = {
  __typename?: 'GeneralServiceSubCategory';
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** A paginated list of GeneralServiceSubCategory items. */
export type GeneralServiceSubCategoryPaginator = {
  __typename?: 'GeneralServiceSubCategoryPaginator';
  /** A list of GeneralServiceSubCategory items. */
  data: Array<GeneralServiceSubCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GeneralServiceTemplate = {
  __typename?: 'GeneralServiceTemplate';
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  service?: Maybe<GeneralService>;
  template: Scalars['String'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['String']>;
};

/** A paginated list of GeneralServiceTemplate items. */
export type GeneralServiceTemplatePaginator = {
  __typename?: 'GeneralServiceTemplatePaginator';
  /** A list of GeneralServiceTemplate items. */
  data: Array<GeneralServiceTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GeneralServicesFilterInput = {
  categories?: InputMaybe<Array<Scalars['Int']>>;
  country?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<Scalars['Int']>>;
  region?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  subcategories?: InputMaybe<Array<Scalars['Int']>>;
  subregion?: InputMaybe<Scalars['String']>;
};

export type HolidayDate = {
  __typename?: 'HolidayDate';
  end_date: Scalars['Date'];
  id: Scalars['ID'];
  start_date: Scalars['Date'];
  title: Scalars['String'];
  user: User;
};

export type HouseRule = {
  __typename?: 'HouseRule';
  children: Array<HouseRule>;
  id: Scalars['ID'];
  parent?: Maybe<HouseRule>;
  value: Scalars['String'];
};

export type HousekeepingService = {
  __typename?: 'HousekeepingService';
  children: Array<HousekeepingService>;
  id: Scalars['ID'];
  parent?: Maybe<HousekeepingService>;
  value: Scalars['String'];
};

export type ImportPropertyInput = {
  provider: Scalars['String'];
  providerId: Scalars['ID'];
};

export type Inquiry = {
  __typename?: 'Inquiry';
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  type?: Maybe<InquiryType>;
};

export type InquiryType = InquiryTypeCallback | InquiryTypeGeneral | InquiryTypeSpecific;

export type InquiryTypeCallback = {
  __typename?: 'InquiryTypeCallback';
  id: Scalars['ID'];
  inquiry: Inquiry;
};

export type InquiryTypeGeneral = {
  __typename?: 'InquiryTypeGeneral';
  id: Scalars['ID'];
  inquiry: Inquiry;
};

export type InquiryTypeSpecific = {
  __typename?: 'InquiryTypeSpecific';
  id: Scalars['ID'];
  inquiry: Inquiry;
};

export type InternalNotes = {
  __typename?: 'InternalNotes';
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type InternalNotesPropertyPossibleIssue = {
  __typename?: 'InternalNotesPropertyPossibleIssue';
  id: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
};

export type LinenTowelsService = {
  __typename?: 'LinenTowelsService';
  children: Array<LinenTowelsService>;
  id: Scalars['ID'];
  parent?: Maybe<LinenTowelsService>;
  value: Scalars['String'];
};

/** Location */
export enum Location {
  /** Usa */
  Usa = 'USA'
}

export type LoginMethods = {
  __typename?: 'LoginMethods';
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  google?: Maybe<Scalars['String']>;
};

export type LoginMethodsInput = {
  email?: InputMaybe<Scalars['InputValue']>;
  facebook?: InputMaybe<Scalars['InputValue']>;
  google?: InputMaybe<Scalars['InputValue']>;
};

export type MagazineArticle = {
  __typename?: 'MagazineArticle';
  author: MagazineAuthor;
  categories: Array<MagazineCategory>;
  content: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  destination?: Maybe<MagazineDestination>;
  excerpt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slug: Scalars['String'];
  tags: Scalars['String'];
  thumbnail?: Maybe<MagazineThumbnail>;
  title: Scalars['String'];
  updated_at: Scalars['String'];
};

export type MagazineArticlePaginator = {
  __typename?: 'MagazineArticlePaginator';
  data: Array<MagazineArticle>;
  paginatorInfo: PaginatorInfo;
};

export type MagazineArticlesFilterInput = {
  country: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  subregion?: InputMaybe<Scalars['String']>;
};

export type MagazineAuthor = {
  __typename?: 'MagazineAuthor';
  bio: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MagazineCategory = {
  __typename?: 'MagazineCategory';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type MagazineDestination = {
  __typename?: 'MagazineDestination';
  country: Scalars['String'];
  region: Scalars['String'];
  subregion: Scalars['String'];
};

export type MagazineThumbnail = {
  __typename?: 'MagazineThumbnail';
  alt_text?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
};

/** Meal format */
export enum MealFormat {
  /** Breakfast */
  Breakfast = 'BREAKFAST',
  /** Dinner */
  Dinner = 'DINNER',
  /** Lunch */
  Lunch = 'LUNCH'
}

/** Meal type */
export enum MealType {
  /** Buffet */
  Buffet = 'BUFFET',
  /** Sit down */
  SitDown = 'SIT_DOWN'
}

/** Meals */
export enum Meals {
  /** Daily one */
  DailyOne = 'DAILY_ONE',
  /** Daily three */
  DailyThree = 'DAILY_THREE',
  /** Daily two */
  DailyTwo = 'DAILY_TWO',
  /** One meal */
  OneMeal = 'ONE_MEAL',
  /** Several meals */
  SeveralMeals = 'SEVERAL_MEALS'
}

export type Media = {
  __typename?: 'Media';
  file_name: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

/** Membership type */
export enum MembershipType {
  /** Classic */
  Classic = 'CLASSIC',
  /** Gold */
  Gold = 'GOLD',
  /** Registered */
  Registered = 'REGISTERED',
  /** Silver */
  Silver = 'SILVER'
}

export type MergeUserAccountsInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  booking_channel?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_methods?: InputMaybe<LoginMethodsInput>;
  membership_type?: InputMaybe<Scalars['String']>;
  passport_id?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_country_code?: InputMaybe<Scalars['String']>;
  primary_user_id: Scalars['ID'];
  profile_image_id?: InputMaybe<Scalars['ID']>;
  secondary_user_id: Scalars['ID'];
  stripe_verification_session_id?: InputMaybe<Scalars['InputValue']>;
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Media>>;
  content: Scalars['String'];
  conversation?: Maybe<MessageConversation>;
  created_at: Scalars['DateTimeTz'];
  formatted_content?: Maybe<FormattedContent>;
  id: Scalars['ID'];
  my_read_message?: Maybe<Array<Maybe<ReadMessage>>>;
  read_messages?: Maybe<Array<Maybe<ReadMessage>>>;
  template?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type MessageContent = {
  __typename?: 'MessageContent';
  text: Scalars['String'];
};

export type MessageConversation = {
  __typename?: 'MessageConversation';
  conversationable?: Maybe<ConversationableUnion>;
  human_time: Scalars['String'];
  id: Scalars['ID'];
  is_starred: Scalars['Boolean'];
  last_message: Message;
  last_messaged_at: Scalars['DateTime'];
  messages: MessagePaginator;
  pivot?: Maybe<MessageConversationUsersPivot>;
  recipients: Array<Recipient>;
  title: Scalars['String'];
  unread_count: Scalars['Int'];
  users: Array<User>;
};


export type MessageConversationMessagesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type MessageConversationRecipientsArgs = {
  view_as?: InputMaybe<Scalars['ID']>;
};

/** A paginated list of MessageConversation items. */
export type MessageConversationPaginator = {
  __typename?: 'MessageConversationPaginator';
  /** A list of MessageConversation items. */
  data: Array<MessageConversation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type MessageConversationUsersPivot = {
  __typename?: 'MessageConversationUsersPivot';
  id: Scalars['ID'];
  is_starred: Scalars['Boolean'];
};

/** A paginated list of Message items. */
export type MessagePaginator = {
  __typename?: 'MessagePaginator';
  /** A list of Message items. */
  data: Array<Message>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeInquiryStatus: Scalars['Boolean'];
  confirmPaymentGroup: PaymentGroup;
  createAirportTransferSurvey: Scalars['Boolean'];
  createBankInfoSurvey: Scalars['Boolean'];
  createBoatCharterSurvey: Scalars['Boolean'];
  createCarRentalSurvey: Scalars['Boolean'];
  createConversation?: Maybe<MessageConversation>;
  createHolidayDate?: Maybe<HolidayDate>;
  createMessage?: Maybe<Message>;
  createPreStockingSurvey: Scalars['Boolean'];
  createPrivateChefSurvey: Scalars['Boolean'];
  deleteHolidayDate?: Maybe<Scalars['Boolean']>;
  deleteMessage?: Maybe<Message>;
  downloadPropertyBrochure?: Maybe<Array<Maybe<Media>>>;
  downloadServiceRequestPdf?: Maybe<DownloadPdfType>;
  duplicateProperty?: Maybe<Property>;
  endOutOfOfficeMode: Scalars['Boolean'];
  importProperty?: Maybe<Property>;
  markServicePaymentsPending: PaymentGroup;
  mergeUserAccountsMutation?: Maybe<User>;
  outOfOfficeMode: Booking;
  sendInquiryToPartner: Scalars['Boolean'];
  tripScheduleSendForApproval: Response;
  updateConfirmedBooking: Booking;
  updateConversation?: Maybe<MessageConversation>;
  updateHolidayDate?: Maybe<HolidayDate>;
  updateMessage?: Maybe<Message>;
  updateProperty?: Maybe<Property>;
  updateTeamMemberGeneralInformation?: Maybe<User>;
  validateAirportTransferSurvey: Scalars['Boolean'];
  validateBankInfoSurvey: Scalars['Boolean'];
  validateBoatCharterSurvey: Scalars['Boolean'];
  validateCarRentalSurvey: Scalars['Boolean'];
  validatePreStockingSurvey: Scalars['Boolean'];
  validatePrivateChefSurvey: Scalars['Boolean'];
};


export type MutationChangeInquiryStatusArgs = {
  input: ChangeInquiryStatusInput;
  inquiryId: Scalars['ID'];
};


export type MutationConfirmPaymentGroupArgs = {
  payment_group_id: Scalars['ID'];
};


export type MutationCreateAirportTransferSurveyArgs = {
  input: AirportTransferInput;
};


export type MutationCreateBankInfoSurveyArgs = {
  input: BankInfoInput;
};


export type MutationCreateBoatCharterSurveyArgs = {
  input: BoatCharterInput;
};


export type MutationCreateCarRentalSurveyArgs = {
  input: CarRentalInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateHolidayDateArgs = {
  input: CreateHolidayDateInput;
};


export type MutationCreateMessageArgs = {
  conversationId: Scalars['ID'];
  input: CreateMessageInput;
};


export type MutationCreatePreStockingSurveyArgs = {
  input: PreStockingInput;
};


export type MutationCreatePrivateChefSurveyArgs = {
  input: PrivateChefInput;
};


export type MutationDeleteHolidayDateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageArgs = {
  messageId: Scalars['ID'];
};


export type MutationDownloadPropertyBrochureArgs = {
  isB2b?: InputMaybe<Scalars['Boolean']>;
  propertyIds: Array<Scalars['ID']>;
};


export type MutationDownloadServiceRequestPdfArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicatePropertyArgs = {
  propertyId: Scalars['ID'];
};


export type MutationEndOutOfOfficeModeArgs = {
  input: EndOutOfOfficeModeInput;
};


export type MutationImportPropertyArgs = {
  input: ImportPropertyInput;
};


export type MutationMarkServicePaymentsPendingArgs = {
  bookingId: Scalars['ID'];
  groupIds: Array<Scalars['ID']>;
};


export type MutationMergeUserAccountsMutationArgs = {
  input: MergeUserAccountsInput;
};


export type MutationOutOfOfficeModeArgs = {
  input: UpdateOutOfOfficeModeInput;
};


export type MutationSendInquiryToPartnerArgs = {
  input: SendInquiryToPartnerInput;
  inquiryId: Scalars['ID'];
};


export type MutationTripScheduleSendForApprovalArgs = {
  bookingId: Scalars['ID'];
};


export type MutationUpdateConfirmedBookingArgs = {
  input: UpdateConfirmedBookingInput;
};


export type MutationUpdateConversationArgs = {
  conversationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  isStarred?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateHolidayDateArgs = {
  input: UpdateHolidayDateInput;
};


export type MutationUpdateMessageArgs = {
  isRead?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationUpdatePropertyArgs = {
  input: UpdatePropertyInput;
  propertyId: Scalars['ID'];
};


export type MutationUpdateTeamMemberGeneralInformationArgs = {
  input: UpdateTeamMemberGeneralInformationInput;
};


export type MutationValidateAirportTransferSurveyArgs = {
  input: AirportTransferInput;
};


export type MutationValidateBankInfoSurveyArgs = {
  input: BankInfoInput;
};


export type MutationValidateBoatCharterSurveyArgs = {
  input: BoatCharterInput;
};


export type MutationValidateCarRentalSurveyArgs = {
  input: CarRentalInput;
};


export type MutationValidatePreStockingSurveyArgs = {
  input: PreStockingInput;
};


export type MutationValidatePrivateChefSurveyArgs = {
  input: PrivateChefInput;
};

export type NearestDistance = {
  __typename?: 'NearestDistance';
  distance: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Notes = {
  __typename?: 'Notes';
  contacts?: Maybe<Array<Contacts>>;
  id: Scalars['ID'];
  internal_notes?: Maybe<InternalNotes>;
  pool_rules?: Maybe<Scalars['String']>;
  pool_size?: Maybe<Scalars['String']>;
  pool_type?: Maybe<Scalars['String']>;
  possible_issues?: Maybe<Array<InternalNotesPropertyPossibleIssue>>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OtherService = {
  __typename?: 'OtherService';
  children: Array<OtherService>;
  id: Scalars['ID'];
  parent?: Maybe<OtherService>;
  value: Scalars['String'];
};

export type OutdoorAmenity = {
  __typename?: 'OutdoorAmenity';
  children: Array<OutdoorAmenity>;
  id: Scalars['ID'];
  parent?: Maybe<OutdoorAmenity>;
  value: Scalars['String'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type PartnerTeamContacts = {
  __typename?: 'PartnerTeamContacts';
  active: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  partner_id: Scalars['ID'];
  phone?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  additionalFees?: Maybe<Array<AdditionalFee>>;
  amount: Scalars['Int'];
  due_date: Scalars['Date'];
  id: Scalars['ID'];
  payment_type: Scalars['String'];
  servicePaymentParts?: Maybe<Array<ServicePaymentPart>>;
};

export type PaymentGroup = {
  __typename?: 'PaymentGroup';
  amount: Scalars['Int'];
  booking: Booking;
  client_secret?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  paid_at?: Maybe<Scalars['DateTime']>;
  payments: Array<Payment>;
  session_id?: Maybe<Scalars['String']>;
  stripe_information?: Maybe<StripeInformation>;
};

export type PaymentTotals = {
  __typename?: 'PaymentTotals';
  completed?: Maybe<Scalars['Int']>;
  due?: Maybe<Scalars['Int']>;
  pending?: Maybe<Scalars['Int']>;
};

export type Position = {
  __typename?: 'Position';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PreStockingInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question2?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question3?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question4?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question5?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question6?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question7?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question8?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question9?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question10?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question11?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question12?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question13?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  question14?: InputMaybe<Array<SurveyPreStockingInfoInput>>;
  slide_number: Scalars['Int'];
};

export type PreviousVerificationSession = {
  __typename?: 'PreviousVerificationSession';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  stripe_verification_session_id: Scalars['String'];
  user: User;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type PrivateChefInput = {
  booking_id: Scalars['ID'];
  position: Scalars['Int'];
  question1?: InputMaybe<PrivateChefQuestion1Input>;
  question2?: InputMaybe<PrivateChefQuestion2Input>;
  question3?: InputMaybe<PrivateChefQuestion3Input>;
  question4?: InputMaybe<PrivateChefQuestion4Input>;
  question5?: InputMaybe<PrivateChefQuestion5Input>;
  question6?: InputMaybe<PrivateChefQuestion6Input>;
  slide_number: Scalars['Int'];
};

export type PrivateChefQuestion1Input = {
  daily_one_format?: InputMaybe<Scalars['InputValue']>;
  daily_two_format?: InputMaybe<Array<InputMaybe<Scalars['InputValue']>>>;
  meal_count?: InputMaybe<Scalars['InputValue']>;
  meals?: InputMaybe<Scalars['InputValue']>;
};

export type PrivateChefQuestion2Input = {
  preferences: Array<InputMaybe<PrivateChefQuestion2PreferencesInput>>;
};

export type PrivateChefQuestion2PreferencesInput = {
  adults?: InputMaybe<Scalars['InputValue']>;
  children?: InputMaybe<Scalars['InputValue']>;
  cuisine?: InputMaybe<Scalars['InputValue']>;
  date?: InputMaybe<Scalars['InputValue']>;
  end_time?: InputMaybe<Scalars['InputValue']>;
  start_time?: InputMaybe<Scalars['InputValue']>;
  type?: InputMaybe<Scalars['InputValue']>;
};

export type PrivateChefQuestion3Input = {
  child_menu?: InputMaybe<Scalars['InputValue']>;
};

export type PrivateChefQuestion4Input = {
  child_age?: InputMaybe<Scalars['InputValue']>;
};

export type PrivateChefQuestion5Input = {
  allergies?: InputMaybe<Scalars['InputValue']>;
  has_allergies?: InputMaybe<Scalars['InputValue']>;
};

export type PrivateChefQuestion6Input = {
  occasion?: InputMaybe<Scalars['InputValue']>;
};

export type PropertiesOrderByClause = {
  column: PropertiesOrderByColumn;
  order: SortOrder;
};

/** Properties order by column */
export enum PropertiesOrderByColumn {
  /** Bedrooms */
  Bedrooms = 'BEDROOMS',
  /** Popularity */
  Popularity = 'POPULARITY',
  /** Price range */
  PriceRange = 'PRICE_RANGE',
  /** Stay cost */
  StayCost = 'STAY_COST',
  /** Title */
  Title = 'TITLE'
}

export type Property = {
  __typename?: 'Property';
  additional_costs: Array<AdditionalCost>;
  additional_house_rules?: Maybe<Scalars['String']>;
  address?: Maybe<PropertyAddress>;
  agent_price_range?: Maybe<PriceRange>;
  agent_stay_cost?: Maybe<Scalars['Int']>;
  available?: Maybe<Scalars['Boolean']>;
  bathrooms?: Maybe<Scalars['Float']>;
  bedroom_arrangements: Array<BedroomArrangement>;
  bedrooms?: Maybe<Scalars['Int']>;
  calendar_source?: Maybe<Scalars['String']>;
  city?: Maybe<DestinationCity>;
  commission_percentage?: Maybe<Scalars['Int']>;
  country?: Maybe<DestinationCountry>;
  currency: CurrencyType;
  description?: Maybe<Scalars['String']>;
  entertainment_amenities: Array<EntertainmentAmenity>;
  extra_additional_costs?: Maybe<Scalars['String']>;
  garden_sq?: Maybe<Scalars['Int']>;
  general_amenities: Array<GeneralAmenity>;
  guests?: Maybe<Scalars['Int']>;
  house_rules: Array<HouseRule>;
  house_sq?: Maybe<Scalars['Int']>;
  housekeeping_services: Array<HousekeepingService>;
  id: Scalars['ID'];
  images: Array<Media>;
  is_private?: Maybe<Scalars['Boolean']>;
  linen_towels_services: Array<LinenTowelsService>;
  main_image?: Maybe<Media>;
  main_image_alt_text?: Maybe<Scalars['String']>;
  minimum_stay?: Maybe<Scalars['Int']>;
  nearest_distance_four?: Maybe<NearestDistance>;
  nearest_distance_one?: Maybe<NearestDistance>;
  nearest_distance_three?: Maybe<NearestDistance>;
  nearest_distance_two?: Maybe<NearestDistance>;
  notes?: Maybe<Notes>;
  number_of_bookings?: Maybe<Scalars['Int']>;
  other_services: Array<OtherService>;
  outdoor_amenities: Array<OutdoorAmenity>;
  owner?: Maybe<User>;
  partner?: Maybe<PropertyPartner>;
  position: Position;
  price_range?: Maybe<PriceRange>;
  property_rental_due?: Maybe<PropertyRentalDue>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['ID']>;
  provider_last_synced_at?: Maybe<Scalars['DateTime']>;
  public_events: Array<Event>;
  published?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  region?: Maybe<DestinationRegion>;
  rental_due?: Maybe<RentalDue>;
  reviews: Array<Review>;
  security_deposit?: Maybe<SecurityDeposit>;
  seo: SeoDetails;
  slug: Scalars['String'];
  staff_services: Array<StaffService>;
  stay_cost?: Maybe<Scalars['Int']>;
  sub_heading?: Maybe<Scalars['String']>;
  sub_region?: Maybe<DestinationSubRegion>;
  sync_token?: Maybe<Scalars['String']>;
  tag_design_styles: Array<TagDesignStyle>;
  tag_highlights: Array<TagHighlight>;
  tag_holiday_types: Array<TagHolidayType>;
  tag_types: Array<TagType>;
  title: Scalars['String'];
  url: Scalars['String'];
};


export type PropertyAgent_Stay_CostArgs = {
  details?: InputMaybe<PropertyPriceInput>;
};


export type PropertyAvailableArgs = {
  details?: InputMaybe<PropertyPriceInput>;
};


export type PropertyMinimum_StayArgs = {
  details?: InputMaybe<PropertyPriceInput>;
};


export type PropertyStay_CostArgs = {
  details?: InputMaybe<PropertyPriceInput>;
};

export type PropertyAddress = {
  __typename?: 'PropertyAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line_1?: Maybe<Scalars['String']>;
  line_2?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  single_line?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PropertyFiltersInput = {
  adults?: InputMaybe<Scalars['Int']>;
  amenities_entertainment?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  amenities_general?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  amenities_outdoor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  arrival?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  children?: InputMaybe<Scalars['Int']>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  departure?: InputMaybe<Scalars['String']>;
  destination_filters?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isB2b?: InputMaybe<Scalars['Boolean']>;
  maxCost?: InputMaybe<Scalars['Float']>;
  minCost?: InputMaybe<Scalars['Float']>;
  property_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  property_tag_design_styles?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  property_tag_highlights?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  property_tag_holiday_types?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  property_tag_types?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  search?: InputMaybe<Scalars['String']>;
  subRegions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** A paginated list of Property items. */
export type PropertyPaginator = {
  __typename?: 'PropertyPaginator';
  /** A list of Property items. */
  data: Array<Property>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PropertyPartner = {
  __typename?: 'PropertyPartner';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type PropertyPriceInput = {
  arrival: Scalars['String'];
  departure: Scalars['String'];
};

export type PropertyRentalDue = {
  __typename?: 'PropertyRentalDue';
  children: Array<PropertyRentalDue>;
  id: Scalars['ID'];
  parent?: Maybe<PropertyRentalDue>;
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  availability?: Maybe<Availability>;
  bookingConfirmationPayment: PaymentGroup;
  cities: DestinationCityPaginator;
  cmsBecomeAMemberSection: CmsBecomeAMemberSection;
  cmsFeaturedProperties: CmsFeaturedPropertiesPaginator;
  cmsGetInTouchSection: CmsGetInTouchSection;
  cmsGuestReviews: CmsGuestReviewPaginator;
  cmsPopularDestinations: CmsPopularDestinationsPaginator;
  continent: DestinationContinent;
  continents: Array<DestinationContinent>;
  conversation?: Maybe<MessageConversation>;
  conversations: MessageConversationPaginator;
  countries: DestinationCountryPaginator;
  country?: Maybe<DestinationCountry>;
  currentUser?: Maybe<User>;
  destinationFilters: DestinationFilterPaginator;
  externalProperties: ExternalPropertyPaginator;
  featuredRegions: DestinationRegionPaginator;
  featuredServices: GeneralServicePaginator;
  health: Scalars['Boolean'];
  holidayDate?: Maybe<HolidayDate>;
  holidayDates: Array<HolidayDate>;
  magazineArticles?: Maybe<MagazineArticlePaginator>;
  message?: Maybe<Message>;
  paymentGroup: PaymentGroup;
  popularServices: GeneralServicePaginator;
  possibleIssues?: Maybe<Array<InternalNotesPropertyPossibleIssue>>;
  properties: PropertyPaginator;
  property?: Maybe<Property>;
  propertyCount: Scalars['Int'];
  randomRegion?: Maybe<DestinationRegion>;
  region?: Maybe<DestinationRegion>;
  regions: DestinationRegionPaginator;
  service?: Maybe<GeneralService>;
  serviceCategories: GeneralServiceCategoryPaginator;
  serviceFilters: GeneralServiceFilterPaginator;
  serviceRequest?: Maybe<ServiceRequest>;
  serviceSubCategories: GeneralServiceSubCategoryPaginator;
  serviceTemplates: GeneralServiceTemplatePaginator;
  services: GeneralServicePaginator;
  subRegion?: Maybe<DestinationSubRegion>;
  subRegions: DestinationSubRegionPaginator;
  surveyBankInfo: SurveyBankInfo;
  tripScheduleGroups: Array<TripScheduleGroup>;
  tripSchedulePayment: TripSchedulePayment;
  user?: Maybe<User>;
  /** Get a list of users */
  users: UserPaginator;
  /** The Auth user's verification session, if this exists then it is pulled from Stripe Identity, otherwise a new session is created. */
  verificationSession?: Maybe<VerificationSession>;
};


export type QueryAvailabilityArgs = {
  input: AvailabilityInput;
};


export type QueryBookingConfirmationPaymentArgs = {
  booking_token: Scalars['String'];
};


export type QueryCitiesArgs = {
  filters?: InputMaybe<CitiesFilterInput>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCmsFeaturedPropertiesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCmsGuestReviewsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCmsPopularDestinationsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryContinentArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryContinentsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryConversationArgs = {
  id: Scalars['ID'];
};


export type QueryConversationsArgs = {
  filters?: InputMaybe<ConversationFiltersInput>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCountriesArgs = {
  filters?: InputMaybe<CountriesFilterInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryDestinationFiltersArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['ID']>;
};


export type QueryExternalPropertiesArgs = {
  first: Scalars['Int'];
  input?: InputMaybe<ExternalPropertiesInput>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryFeaturedRegionsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryFeaturedServicesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryHolidayDateArgs = {
  id: Scalars['ID'];
};


export type QueryHolidayDatesArgs = {
  booking_id?: InputMaybe<Scalars['ID']>;
  show_previous?: InputMaybe<Scalars['Boolean']>;
  user_id: Scalars['ID'];
};


export type QueryMagazineArticlesArgs = {
  filters?: InputMaybe<MagazineArticlesFilterInput>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentGroupArgs = {
  payment_group_id: Scalars['ID'];
};


export type QueryPopularServicesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertiesArgs = {
  filters?: InputMaybe<PropertyFiltersInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<PropertiesOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyArgs = {
  id: Scalars['ID'];
};


export type QueryRandomRegionArgs = {
  filters?: InputMaybe<RandomRegionFiltersInput>;
};


export type QueryRegionArgs = {
  slug: Scalars['String'];
};


export type QueryRegionsArgs = {
  filters?: InputMaybe<RegionsFilterInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<DestinationRegionOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryServiceArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  survey_slug?: InputMaybe<Scalars['String']>;
};


export type QueryServiceCategoriesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryServiceFiltersArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  parent_id_not_equals?: InputMaybe<Scalars['ID']>;
};


export type QueryServiceRequestArgs = {
  id: Scalars['ID'];
};


export type QueryServiceSubCategoriesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryServiceTemplatesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  service_id?: InputMaybe<Scalars['ID']>;
};


export type QueryServicesArgs = {
  filters?: InputMaybe<GeneralServicesFilterInput>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<GeneralServiceOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySubRegionArgs = {
  slug: Scalars['String'];
};


export type QuerySubRegionsArgs = {
  filters?: InputMaybe<SubRegionsFilterInput>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveyBankInfoArgs = {
  id: Scalars['ID'];
};


export type QueryTripScheduleGroupsArgs = {
  bookingId: Scalars['ID'];
};


export type QueryTripSchedulePaymentArgs = {
  bookingId: Scalars['ID'];
  groupIds: Array<Scalars['ID']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type RandomRegionFiltersInput = {
  continent_id?: InputMaybe<Scalars['ID']>;
  country_ids?: InputMaybe<Array<Scalars['ID']>>;
  property_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type ReadMessage = {
  __typename?: 'ReadMessage';
  created_at: Scalars['DateTimeTz'];
  id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type Recipient = AmaRecipient | User;

export type RegionsFilterInput = {
  continent_id?: InputMaybe<Scalars['ID']>;
  country_id?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type RentalDue = {
  __typename?: 'RentalDue';
  id: Scalars['ID'];
  value: Scalars['Int'];
};

export type Response = {
  __typename?: 'Response';
  approval_sent_at?: Maybe<Scalars['DateTime']>;
  statusCode?: Maybe<Scalars['Int']>;
};

export type Review = {
  __typename?: 'Review';
  id: Scalars['ID'];
  name: Scalars['String'];
  property: Property;
  rating: Scalars['Int'];
  source?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type SecurityDeposit = {
  __typename?: 'SecurityDeposit';
  children: Array<SecurityDeposit>;
  id: Scalars['ID'];
  parent?: Maybe<SecurityDeposit>;
  value: Scalars['Int'];
};

export type SendInquiryToPartnerInput = {
  contact_ids?: InputMaybe<Array<Scalars['Int']>>;
  message?: InputMaybe<Scalars['String']>;
  partner_id?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SeoDetails = {
  __typename?: 'SeoDetails';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum ServicePartnerPrice {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED'
}

export type ServicePayment = {
  __typename?: 'ServicePayment';
  id: Scalars['ID'];
  name: Scalars['String'];
  trip_schedule_id?: Maybe<Scalars['ID']>;
};

export type ServicePaymentPart = {
  __typename?: 'ServicePaymentPart';
  id: Scalars['ID'];
  name: Scalars['String'];
  percentage: Scalars['Int'];
  servicePayment?: Maybe<ServicePayment>;
};

export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  booking: Booking;
  created_at: Scalars['DateTime'];
  details?: Maybe<Array<ServiceRequestDetail>>;
  id: Scalars['ID'];
  request_id: Scalars['String'];
  service: GeneralService;
  status: ServiceRequestStatus;
  survey_id?: Maybe<Scalars['ID']>;
  trip_service?: Maybe<TripScheduleGroup>;
  updated_at: Scalars['DateTime'];
  user: User;
};

export type ServiceRequestDetail = {
  __typename?: 'ServiceRequestDetail';
  answer?: Maybe<Scalars['String']>;
  question: Scalars['String'];
};

/** Service request status */
export enum ServiceRequestStatus {
  /** Added */
  Added = 'ADDED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Closed */
  Closed = 'CLOSED',
  /** Pending */
  Pending = 'PENDING',
  /** Sent to partner */
  SentToPartner = 'SENT_TO_PARTNER'
}

/** Service survey */
export enum ServiceSurvey {
  /** Airport transfer */
  AirportTransfer = 'AIRPORT_TRANSFER',
  /** Boat charter */
  BoatCharter = 'BOAT_CHARTER',
  /** Car rental */
  CarRental = 'CAR_RENTAL',
  /** Pre stocking */
  PreStocking = 'PRE_STOCKING',
  /** Private chef */
  PrivateChef = 'PRIVATE_CHEF',
  /** Sailboat charter */
  SailboatCharter = 'SAILBOAT_CHARTER'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type StaffService = {
  __typename?: 'StaffService';
  children: Array<StaffService>;
  id: Scalars['ID'];
  parent?: Maybe<StaffService>;
  value: Scalars['String'];
};

export type StripeInformation = {
  __typename?: 'StripeInformation';
  amount: Scalars['Int'];
  amount_charged: Scalars['Int'];
  amount_received: Scalars['Int'];
  card_brand: Scalars['String'];
  charge_currency: Scalars['String'];
  fee: Scalars['Int'];
  id: Scalars['ID'];
  receive_currency: Scalars['String'];
};

export type SubRegionsFilterInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type SurveyAirportTransfer = {
  __typename?: 'SurveyAirportTransfer';
  anything_else: Scalars['String'];
  arrivalTransferData: Array<SurveyAirportTransferData>;
  arrival_transfer: Scalars['Int'];
  departureTransferData: Array<SurveyAirportTransferData>;
  departure_transfer: Scalars['Int'];
  id: Scalars['ID'];
};

export type SurveyAirportTransferData = {
  __typename?: 'SurveyAirportTransferData';
  adults: Scalars['Int'];
  child_ages?: Maybe<Scalars['Int']>;
  child_seats?: Maybe<Scalars['Int']>;
  children?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  flight_number: Scalars['String'];
  main_guest_name: Scalars['String'];
  main_guest_phone: Scalars['String'];
  main_guest_phone_code: Scalars['Int'];
  start_time: Scalars['String'];
  survey?: Maybe<SurveyAirportTransfer>;
  type: AirportTransferDataType;
};

export type SurveyBankInfo = {
  __typename?: 'SurveyBankInfo';
  account_number?: Maybe<Scalars['String']>;
  bank_address: Scalars['String'];
  bank_name: Scalars['String'];
  beneficiary_name: Scalars['String'];
  bic_swift_code?: Maybe<Scalars['String']>;
  booking: Booking;
  created_at: Scalars['DateTime'];
  details: Array<SurveyBankInfoDetail>;
  grade: Scalars['Int'];
  iban_code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items_to_be_improved: Scalars['String'];
  location: Scalars['String'];
  personal_note?: Maybe<Scalars['String']>;
  routing_number?: Maybe<Scalars['String']>;
  tip?: Maybe<Scalars['Int']>;
  updated_at: Scalars['DateTime'];
  user: User;
};

export type SurveyBankInfoDetail = {
  __typename?: 'SurveyBankInfoDetail';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SurveyBoatCharter = {
  __typename?: 'SurveyBoatCharter';
  anything_else: Scalars['String'];
  duration: DurationType;
  id: Scalars['ID'];
  info: SurveyBoatCharterInfo;
};

export type SurveyBoatCharterInfo = {
  __typename?: 'SurveyBoatCharterInfo';
  adults: Scalars['Int'];
  boat_type: Scalars['String'];
  budget: Scalars['String'];
  child_ages?: Maybe<Scalars['String']>;
  children?: Maybe<Scalars['Int']>;
  duration: Scalars['String'];
  end_date?: Maybe<Scalars['Date']>;
  start_date?: Maybe<Scalars['Date']>;
  survey?: Maybe<SurveyBoatCharter>;
};

export type SurveyCarRental = {
  __typename?: 'SurveyCarRental';
  anything_else?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SurveyCarRentalInfo = {
  __typename?: 'SurveyCarRentalInfo';
  car_type: Scalars['String'];
  child_ages: Scalars['String'];
  child_seats: Scalars['Int'];
  date: Scalars['Date'];
  end_time: Scalars['DateTime'];
  id: Scalars['ID'];
  pick_up_drop_off: Scalars['String'];
  start_time: Scalars['DateTime'];
};

export type SurveyPreStocking = {
  __typename?: 'SurveyPreStocking';
  id: Scalars['ID'];
};

export type SurveyPreStockingInfo = {
  __typename?: 'SurveyPreStockingInfo';
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  organic: Scalars['Boolean'];
  quantity: Scalars['Int'];
  sub_type: Scalars['String'];
  survey?: Maybe<SurveyBoatCharter>;
  survey_id: Scalars['ID'];
  type: Scalars['String'];
};

export type SurveyPreStockingInfoInput = {
  notes?: InputMaybe<Scalars['InputValue']>;
  organic?: InputMaybe<Scalars['InputValue']>;
  quantity?: InputMaybe<Scalars['InputValue']>;
  sub_type?: InputMaybe<Scalars['InputValue']>;
};

export type SurveyPrivateChef = {
  __typename?: 'SurveyPrivateChef';
  allergies?: Maybe<Scalars['String']>;
  child_age?: Maybe<Scalars['String']>;
  child_menu?: Maybe<SurveyYesNo>;
  has_allergies: SurveyYesNo;
  id: Scalars['ID'];
  mealPreferences: Array<SurveyPrivateChefMeal>;
  meal_count?: Maybe<Scalars['Int']>;
  meals: Meals;
  occasion: Scalars['String'];
};

export type SurveyPrivateChefMeal = {
  __typename?: 'SurveyPrivateChefMeal';
  adults: Scalars['Int'];
  children: Scalars['Int'];
  cuisine: Scalars['String'];
  date: Scalars['Date'];
  end_time?: Maybe<Scalars['String']>;
  format: MealFormat;
  id: Scalars['ID'];
  start_time: Scalars['String'];
  survey?: Maybe<SurveyPrivateChef>;
  type: MealType;
};

/** Survey yes no */
export enum SurveyYesNo {
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

export type TagDesignStyle = {
  __typename?: 'TagDesignStyle';
  children: Array<TagDesignStyle>;
  id: Scalars['ID'];
  parent?: Maybe<TagDesignStyle>;
  value: Scalars['String'];
};

export type TagHighlight = {
  __typename?: 'TagHighlight';
  children: Array<TagHighlight>;
  id: Scalars['ID'];
  parent?: Maybe<TagHighlight>;
  value: Scalars['String'];
};

export type TagHolidayType = {
  __typename?: 'TagHolidayType';
  children: Array<TagHolidayType>;
  id: Scalars['ID'];
  parent?: Maybe<TagHolidayType>;
  value: Scalars['String'];
};

export type TagType = {
  __typename?: 'TagType';
  children: Array<TagType>;
  id: Scalars['ID'];
  parent?: Maybe<TagType>;
  value: Scalars['String'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TripScheduleGroup = {
  __typename?: 'TripScheduleGroup';
  commission_amount?: Maybe<Scalars['Int']>;
  commission_included?: Maybe<ServicePartnerPrice>;
  commission_type?: Maybe<CommissionType>;
  days?: Maybe<Array<TripScheduleService>>;
  id: Scalars['ID'];
  is_price_generated?: Maybe<Scalars['Boolean']>;
  partner_price?: Maybe<Scalars['Int']>;
  payment_totals?: Maybe<PaymentTotals>;
  price?: Maybe<Scalars['Int']>;
  service_fee?: Maybe<Scalars['Int']>;
  service_fee_application?: Maybe<CommissionApplication>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TripSchedulePayment = {
  __typename?: 'TripSchedulePayment';
  amount: Scalars['Int'];
  client_secret?: Maybe<Scalars['String']>;
  payments: Array<TripSchedulePaymentData>;
};

export type TripSchedulePaymentData = {
  __typename?: 'TripSchedulePaymentData';
  payment_type?: Maybe<Scalars['String']>;
};

export type TripScheduleService = {
  __typename?: 'TripScheduleService';
  id: Scalars['ID'];
};

export type UpdateConfirmedBookingDateInput = {
  arrival?: InputMaybe<Scalars['Date']>;
  departure?: InputMaybe<Scalars['Date']>;
};

export type UpdateConfirmedBookingInput = {
  booking_id?: InputMaybe<Scalars['ID']>;
  new_dates?: InputMaybe<UpdateConfirmedBookingDateInput>;
  new_property?: InputMaybe<UpdateConfirmedBookingPropertyInput>;
  price_option?: InputMaybe<UpdateConfirmedBookingPriceOption>;
};

export enum UpdateConfirmedBookingPriceOption {
  Keep = 'KEEP',
  Update = 'UPDATE'
}

export type UpdateConfirmedBookingPropertyInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateHolidayDateInput = {
  end_date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['Date']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOutOfOfficeModeInput = {
  booking_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['Date']>;
  holiday_date_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['Date']>;
  temporary_concierge_id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePropertyInput = {
  commission_percentage?: InputMaybe<Scalars['InputValue']>;
  currency?: InputMaybe<Scalars['InputValue']>;
};

export type UpdateTeamMemberGeneralInformationInput = {
  about?: InputMaybe<Scalars['String']>;
  calendly_link?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  job_title?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_country_code?: InputMaybe<Scalars['String']>;
  profile_image?: InputMaybe<Scalars['Upload']>;
  status?: InputMaybe<Scalars['String']>;
  sub_type?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  booking_channel?: Maybe<Scalars['String']>;
  bookings?: Maybe<Array<Booking>>;
  bookingsPaginated: BookingPaginator;
  commission?: Maybe<Scalars['Int']>;
  conversations?: Maybe<Array<MessageConversation>>;
  credit?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['ID'];
  identity_verified_at?: Maybe<Scalars['DateTime']>;
  inquiries_general?: Maybe<Array<InquiryTypeGeneral>>;
  inquiries_specific?: Maybe<Array<InquiryTypeCallback>>;
  last_name: Scalars['String'];
  login_methods?: Maybe<LoginMethods>;
  membership_type?: Maybe<MembershipType>;
  partnerTeamContacts?: Maybe<Array<PartnerTeamContacts>>;
  passport_image?: Maybe<Media>;
  phone?: Maybe<Scalars['String']>;
  phone_country_code?: Maybe<Scalars['String']>;
  previous_verification_sessions?: Maybe<Array<PreviousVerificationSession>>;
  profile_image?: Maybe<Media>;
  service_requests?: Maybe<Array<ServiceRequest>>;
  stripe_verification_session_id?: Maybe<Scalars['String']>;
  sub_type: Scalars['String'];
  total_spent?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  unread_count: Scalars['Int'];
};


export type UserBookingsPaginatedArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type UserFiltersInput = {
  search?: InputMaybe<Scalars['String']>;
  sub_type?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type VerificationSession = {
  __typename?: 'VerificationSession';
  client_secret?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: VerificationSessionStatus;
};

export enum VerificationSessionStatus {
  Canceled = 'canceled',
  Processing = 'processing',
  RequiresInput = 'requires_input',
  Verified = 'verified'
}

export type ReadMessageMutationVariables = Exact<{
  messageId: Scalars['ID'];
  isRead: Scalars['Boolean'];
}>;


export type ReadMessageMutation = { __typename?: 'Mutation', updateMessage?: { __typename?: 'Message', id: string, my_read_message?: Array<{ __typename?: 'ReadMessage', id: string, created_at: any } | null> | null, conversation?: { __typename?: 'MessageConversation', id: string, unread_count: number } | null } | null };

export type PublicFooterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicFooterDataQuery = { __typename?: 'Query', featuredRegions: { __typename?: 'DestinationRegionPaginator', data: Array<{ __typename?: 'DestinationRegion', id: string, slug: string, value: string, country: { __typename?: 'DestinationCountry', id: string, slug: string } }> } };

export type StripeInformationModalQueryVariables = Exact<{
  payment_group_id: Scalars['ID'];
}>;


export type StripeInformationModalQuery = { __typename?: 'Query', paymentGroup: { __typename?: 'PaymentGroup', id: string, amount: number, booking: { __typename?: 'Booking', id: string, currency: CurrencyType }, stripe_information?: { __typename?: 'StripeInformation', id: string, fee: number, amount: number, amount_charged: number, amount_received: number, card_brand: string, charge_currency: string, receive_currency: string } | null, payments: Array<{ __typename?: 'Payment', id: string, payment_type: string, due_date: any, amount: number, additionalFees?: Array<{ __typename?: 'AdditionalFee', id: string, name: string, amount: number }> | null, servicePaymentParts?: Array<{ __typename?: 'ServicePaymentPart', id: string, name: string, servicePayment?: { __typename?: 'ServicePayment', id: string, trip_schedule_id?: string | null } | null }> | null }> } };

export type DashboardInboxPropertyQueryQueryVariables = Exact<{
  priceDetails?: InputMaybe<PropertyPriceInput>;
  filters?: InputMaybe<PropertyFiltersInput>;
}>;


export type DashboardInboxPropertyQueryQuery = { __typename?: 'Query', properties: { __typename?: 'PropertyPaginator', data: Array<{ __typename?: 'Property', minimum_stay?: number | null, calendar_source?: string | null, owner?: { __typename?: 'User', id: string, commission?: number | null } | null }> } };

export type UpdatePropertyCommissionMutationVariables = Exact<{
  propertyId: Scalars['ID'];
  input: UpdatePropertyInput;
}>;


export type UpdatePropertyCommissionMutation = { __typename?: 'Mutation', updateProperty?: { __typename?: 'Property', id: string, commission_percentage?: number | null } | null };

export type UpdatePropertyMutationVariables = Exact<{
  propertyId: Scalars['ID'];
  input: UpdatePropertyInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty?: { __typename?: 'Property', id: string, currency: CurrencyType } | null };

export type TripScheduleServiceRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TripScheduleServiceRequestQuery = { __typename?: 'Query', serviceRequest?: { __typename?: 'ServiceRequest', id: string, request_id: string, survey_id?: string | null, status: ServiceRequestStatus, created_at: any, trip_service?: { __typename?: 'TripScheduleGroup', id: string } | null, details?: Array<{ __typename?: 'ServiceRequestDetail', question: string, answer?: string | null }> | null, service: { __typename?: 'GeneralService', id: string, title: string }, user: { __typename?: 'User', id: string, first_name: string, last_name: string }, booking: { __typename?: 'Booking', id: string } } | null };

export type UserDropdownBookingQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  filters?: InputMaybe<UserFiltersInput>;
}>;


export type UserDropdownBookingQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, email: string, phone?: string | null, booking_channel?: string | null, address?: { __typename?: 'Address', single_line: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number } } };

export type AvailabilityUpdateBookingQueryVariables = Exact<{
  input: AvailabilityInput;
}>;


export type AvailabilityUpdateBookingQuery = { __typename?: 'Query', availability?: { __typename?: 'Availability', available?: boolean | null, arrival?: string | null, departure?: string | null, price?: number | null, security_deposit?: number | null, currency?: CurrencyType | null } | null };

export type BookingConfirmationViaBankTransferQueryVariables = Exact<{
  booking_token: Scalars['String'];
}>;


export type BookingConfirmationViaBankTransferQuery = { __typename?: 'Query', bookingConfirmationPayment: { __typename?: 'PaymentGroup', id: string, amount: number, paid_at?: any | null, payments: Array<{ __typename?: 'Payment', id: string, payment_type: string }> } };

export type ConfirmPaymentGroupViaBankTransferMutationVariables = Exact<{
  payment_group_id: Scalars['ID'];
}>;


export type ConfirmPaymentGroupViaBankTransferMutation = { __typename?: 'Mutation', confirmPaymentGroup: { __typename?: 'PaymentGroup', id: string } };

export type MarkServicePaymentsPendingMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkServicePaymentsPendingMutation = { __typename?: 'Mutation', markServicePaymentsPending: { __typename?: 'PaymentGroup', id: string } };

export type PropertyDropdownQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  orderBy?: InputMaybe<Array<PropertiesOrderByClause> | PropertiesOrderByClause>;
  filters?: InputMaybe<PropertyFiltersInput>;
}>;


export type PropertyDropdownQuery = { __typename?: 'Query', properties: { __typename?: 'PropertyPaginator', data: Array<{ __typename?: 'Property', id: string, title: string, reference?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number } } };

export type UserDropdownQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  filters?: InputMaybe<UserFiltersInput>;
}>;


export type UserDropdownQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number } } };

export type PropertyDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyDetailsQuery = { __typename?: 'Query', property?: { __typename?: 'Property', id: string, url: string, title: string, reference?: string | null, calendar_source?: string | null, owner?: { __typename?: 'User', id: string, partnerTeamContacts?: Array<{ __typename?: 'PartnerTeamContacts', id: string, email?: string | null, type: string, first_name?: string | null, last_name?: string | null, phone?: string | null }> | null, profile_image?: { __typename?: 'Media', id: string, url?: string | null } | null } | null, position: { __typename?: 'Position', latitude: number, longitude: number }, address?: { __typename?: 'PropertyAddress', single_line?: string | null } | null, partner?: { __typename?: 'PropertyPartner', url: string, name: string } | null, main_image?: { __typename?: 'Media', url?: string | null } | null, notes?: { __typename?: 'Notes', id: string, pool_size?: string | null, pool_type?: string | null, pool_rules?: string | null, internal_notes?: { __typename?: 'InternalNotes', id: string, message?: string | null } | null, contacts?: Array<{ __typename?: 'Contacts', id: string, full_name?: string | null, email?: string | null, phone?: string | null, role?: string | null }> | null, possible_issues?: Array<{ __typename?: 'InternalNotesPropertyPossibleIssue', id: string, value?: string | null }> | null } | null } | null };

export type PossibleIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type PossibleIssuesQuery = { __typename?: 'Query', possibleIssues?: Array<{ __typename?: 'InternalNotesPropertyPossibleIssue', id: string, value?: string | null }> | null };

export type SendInquiryToPartnerMutationVariables = Exact<{
  inquiryId: Scalars['ID'];
  input: SendInquiryToPartnerInput;
}>;


export type SendInquiryToPartnerMutation = { __typename?: 'Mutation', sendInquiryToPartner: boolean };

export type PropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyQuery = { __typename?: 'Query', property?: { __typename?: 'Property', id: string, partner?: { __typename?: 'PropertyPartner', name: string, url: string } | null } | null };

export type ServiceRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ServiceRequestQuery = { __typename?: 'Query', serviceRequest?: { __typename?: 'ServiceRequest', id: string, request_id: string, status: ServiceRequestStatus, created_at: any, trip_service?: { __typename?: 'TripScheduleGroup', id: string } | null, details?: Array<{ __typename?: 'ServiceRequestDetail', question: string, answer?: string | null }> | null, service: { __typename?: 'GeneralService', id: string, title: string }, user: { __typename?: 'User', id: string, first_name: string, last_name: string }, booking: { __typename?: 'Booking', id: string, concierge?: { __typename?: 'User', id: string } | null, client: { __typename?: 'User', id: string, first_name: string, last_name: string }, event: { __typename?: 'Event', id: string, start_date: any, end_date: any, property: { __typename?: 'Property', id: string, title: string } } } } | null };

export type GetSurveyBankInfoForAdminQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSurveyBankInfoForAdminQuery = { __typename?: 'Query', surveyBankInfo: { __typename?: 'SurveyBankInfo', id: string, user: { __typename?: 'User', first_name: string, last_name: string }, details: Array<{ __typename?: 'SurveyBankInfoDetail', question: string, answer: string }> } };

export type GetSurveyBankInfoForUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSurveyBankInfoForUserQuery = { __typename?: 'Query', surveyBankInfo: { __typename?: 'SurveyBankInfo', id: string, details: Array<{ __typename?: 'SurveyBankInfoDetail', question: string, answer: string }> } };

export type UpdateConfirmedBookingDatesMutationVariables = Exact<{
  input: UpdateConfirmedBookingInput;
}>;


export type UpdateConfirmedBookingDatesMutation = { __typename?: 'Mutation', updateConfirmedBooking: { __typename?: 'Booking', id: string } };

export type UpdateConfirmedBookingPropertyAvailabilityQueryVariables = Exact<{
  input: AvailabilityInput;
}>;


export type UpdateConfirmedBookingPropertyAvailabilityQuery = { __typename?: 'Query', availability?: { __typename?: 'Availability', available?: boolean | null, arrival?: string | null, departure?: string | null, price?: number | null, currency?: CurrencyType | null } | null };

export type UpdateConfirmedBookingPropertyMutationVariables = Exact<{
  input: UpdateConfirmedBookingInput;
}>;


export type UpdateConfirmedBookingPropertyMutation = { __typename?: 'Mutation', updateConfirmedBooking: { __typename?: 'Booking', id: string } };

export type UserDropdownMergeModalQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  filters?: InputMaybe<UserFiltersInput>;
}>;


export type UserDropdownMergeModalQuery = { __typename?: 'Query', users: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, email: string, phone?: string | null, stripe_verification_session_id?: string | null, booking_channel?: string | null, total_spent?: number | null, credit?: number | null, membership_type?: MembershipType | null, address?: { __typename?: 'Address', id: string, single_line: string } | null, login_methods?: { __typename?: 'LoginMethods', email?: string | null, google?: string | null, facebook?: string | null } | null, profile_image?: { __typename?: 'Media', id: string, url?: string | null, file_name: string } | null, passport_image?: { __typename?: 'Media', id: string, url?: string | null, file_name: string } | null, bookings?: Array<{ __typename?: 'Booking', id: string }> | null, conversations?: Array<{ __typename?: 'MessageConversation', id: string, users: Array<{ __typename?: 'User', id: string, first_name: string }>, messages: { __typename?: 'MessagePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', total: number } } }> | null, inquiries_specific?: Array<{ __typename?: 'InquiryTypeCallback', id: string, inquiry: { __typename?: 'Inquiry', id: string } }> | null, inquiries_general?: Array<{ __typename?: 'InquiryTypeGeneral', id: string, inquiry: { __typename?: 'Inquiry', id: string } }> | null, service_requests?: Array<{ __typename?: 'ServiceRequest', id: string }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number } } };

export type MergeUserAccountsMutationMutationVariables = Exact<{
  input: MergeUserAccountsInput;
}>;


export type MergeUserAccountsMutationMutation = { __typename?: 'Mutation', mergeUserAccountsMutation?: { __typename?: 'User', id: string } | null };

export type DuplicatePropertyMutationVariables = Exact<{
  propertyId: Scalars['ID'];
}>;


export type DuplicatePropertyMutation = { __typename?: 'Mutation', duplicateProperty?: { __typename?: 'Property', id: string } | null };

export type SyncPropertyMutationVariables = Exact<{
  input: ImportPropertyInput;
}>;


export type SyncPropertyMutation = { __typename?: 'Mutation', importProperty?: { __typename?: 'Property', id: string } | null };

export type DownloadPropertyBrochureMutationVariables = Exact<{
  propertyIds: Array<Scalars['ID']> | Scalars['ID'];
  isB2b?: InputMaybe<Scalars['Boolean']>;
}>;


export type DownloadPropertyBrochureMutation = { __typename?: 'Mutation', downloadPropertyBrochure?: Array<{ __typename?: 'Media', url?: string | null } | null> | null };

export type SendForApprovalFromTripScheduleMutationVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type SendForApprovalFromTripScheduleMutation = { __typename?: 'Mutation', tripScheduleSendForApproval: { __typename?: 'Response', statusCode?: number | null, approval_sent_at?: any | null } };

export type DownloadServiceRequestPdfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadServiceRequestPdfMutation = { __typename?: 'Mutation', downloadServiceRequestPdf?: { __typename?: 'DownloadPdfType', url?: string | null, error?: string | null } | null };

export type ServiceTemplatesQueryVariables = Exact<{
  serviceId?: InputMaybe<Scalars['ID']>;
}>;


export type ServiceTemplatesQuery = { __typename?: 'Query', serviceTemplates: { __typename?: 'GeneralServiceTemplatePaginator', data: Array<{ __typename?: 'GeneralServiceTemplate', id: string, name: string, type: string, template: string }> } };

export type DestinationSearchResultsQueryVariables = Exact<{
  regionsFilter?: InputMaybe<RegionsFilterInput>;
  subRegionsFilter?: InputMaybe<SubRegionsFilterInput>;
  citiesFilter?: InputMaybe<CitiesFilterInput>;
}>;


export type DestinationSearchResultsQuery = { __typename?: 'Query', regions: { __typename?: 'DestinationRegionPaginator', data: Array<{ __typename?: 'DestinationRegion', id: string, value: string, slug: string, country: { __typename?: 'DestinationCountry', id: string, value: string, slug: string } }> }, subRegions: { __typename?: 'DestinationSubRegionPaginator', data: Array<{ __typename?: 'DestinationSubRegion', id: string, value: string, slug: string, region: { __typename?: 'DestinationRegion', id: string, slug: string, value: string, country: { __typename?: 'DestinationCountry', id: string, value: string, slug: string } } }> }, cities: { __typename?: 'DestinationCityPaginator', data: Array<{ __typename?: 'DestinationCity', id: string, value: string, subRegion: { __typename?: 'DestinationSubRegion', id: string, value: string, slug: string, region: { __typename?: 'DestinationRegion', id: string, value: string, slug: string, country: { __typename?: 'DestinationCountry', id: string, value: string, slug: string } } } }> } };

export type UseTripScheduleQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;


export type UseTripScheduleQuery = { __typename?: 'Query', tripScheduleGroups: Array<{ __typename?: 'TripScheduleGroup', id: string, title?: string | null, status?: string | null, price?: number | null, is_price_generated?: boolean | null, commission_amount?: number | null, commission_included?: ServicePartnerPrice | null, commission_type?: CommissionType | null, partner_price?: number | null, service_fee?: number | null, service_fee_application?: CommissionApplication | null, days?: Array<{ __typename?: 'TripScheduleService', id: string }> | null, payment_totals?: { __typename?: 'PaymentTotals', completed?: number | null } | null }> };

export type CurrentUserIdentityVerifiedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdentityVerifiedAtQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, identity_verified_at?: any | null, passport_image?: { __typename?: 'Media', id: string, url?: string | null, file_name: string } | null } | null };

export type GetVerificationSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVerificationSessionQuery = { __typename?: 'Query', verificationSession?: { __typename?: 'VerificationSession', id: string, client_secret?: string | null, status: VerificationSessionStatus } | null };

export type UseAvailabilityQueryVariables = Exact<{
  input: AvailabilityInput;
}>;


export type UseAvailabilityQuery = { __typename?: 'Query', availability?: { __typename?: 'Availability', available?: boolean | null, arrival?: string | null, departure?: string | null, price?: number | null } | null };

export type ExternalPropertiesQueryVariables = Exact<{
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  input?: InputMaybe<ExternalPropertiesInput>;
}>;


export type ExternalPropertiesQuery = { __typename?: 'Query', externalProperties: { __typename?: 'ExternalPropertyPaginator', data: Array<{ __typename?: 'ExternalProperty', provider: string, providerId: string, title: string, image: string, url: string, property?: { __typename?: 'Property', id: string, url: string, provider_last_synced_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', total: number, lastPage: number } } };

export type BookingConfirmationViaCardPaymentQueryVariables = Exact<{
  booking_token: Scalars['String'];
}>;


export type BookingConfirmationViaCardPaymentQuery = { __typename?: 'Query', bookingConfirmationPayment: { __typename?: 'PaymentGroup', id: string, session_id?: string | null, client_secret?: string | null, paid_at?: any | null } };

export type PaymentGroupViaCardPaymentQueryVariables = Exact<{
  payment_group_id: Scalars['ID'];
}>;


export type PaymentGroupViaCardPaymentQuery = { __typename?: 'Query', paymentGroup: { __typename?: 'PaymentGroup', id: string, session_id?: string | null, client_secret?: string | null, paid_at?: any | null } };

export type PaymentGroupViaBankTransferQueryVariables = Exact<{
  payment_group_id: Scalars['ID'];
}>;


export type PaymentGroupViaBankTransferQuery = { __typename?: 'Query', paymentGroup: { __typename?: 'PaymentGroup', id: string, amount: number, paid_at?: any | null, payments: Array<{ __typename?: 'Payment', id: string, payment_type: string }> } };

export type TripSchedulePaymentViaCardPaymentQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TripSchedulePaymentViaCardPaymentQuery = { __typename?: 'Query', tripSchedulePayment: { __typename?: 'TripSchedulePayment', client_secret?: string | null } };

export type TripSchedulePaymentViaBankTransferQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TripSchedulePaymentViaBankTransferQuery = { __typename?: 'Query', tripSchedulePayment: { __typename?: 'TripSchedulePayment', amount: number, payments: Array<{ __typename?: 'TripSchedulePaymentData', payment_type?: string | null }> } };

export type ValidateBoatCharterSlideMutationVariables = Exact<{
  input: BoatCharterInput;
}>;


export type ValidateBoatCharterSlideMutation = { __typename?: 'Mutation', validateBoatCharterSurvey: boolean };

export type CreateBoatCharterSlideMutationVariables = Exact<{
  input: BoatCharterInput;
}>;


export type CreateBoatCharterSlideMutation = { __typename?: 'Mutation', createBoatCharterSurvey: boolean };

export type ValidateCarRentalSurveySlideMutationVariables = Exact<{
  input: CarRentalInput;
}>;


export type ValidateCarRentalSurveySlideMutation = { __typename?: 'Mutation', validateCarRentalSurvey: boolean };

export type CreateCarRentalSurveyMutationVariables = Exact<{
  input: CarRentalInput;
}>;


export type CreateCarRentalSurveyMutation = { __typename?: 'Mutation', createCarRentalSurvey: boolean };

export type ValidatePreStockingSlideMutationVariables = Exact<{
  input: PreStockingInput;
}>;


export type ValidatePreStockingSlideMutation = { __typename?: 'Mutation', validatePreStockingSurvey: boolean };

export type CreatePreStockingSlideMutationVariables = Exact<{
  input: PreStockingInput;
}>;


export type CreatePreStockingSlideMutation = { __typename?: 'Mutation', createPreStockingSurvey: boolean };

export type ValidatePrivateChefSurveySlideMutationVariables = Exact<{
  input: PrivateChefInput;
}>;


export type ValidatePrivateChefSurveySlideMutation = { __typename?: 'Mutation', validatePrivateChefSurvey: boolean };

export type CreatePrivateChefSurveyMutationVariables = Exact<{
  input: PrivateChefInput;
}>;


export type CreatePrivateChefSurveyMutation = { __typename?: 'Mutation', createPrivateChefSurvey: boolean };


export const ReadMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"readMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isRead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isRead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isRead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"my_read_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unread_count"}}]}}]}}]}}]} as unknown as DocumentNode<ReadMessageMutation, ReadMessageMutationVariables>;
export const PublicFooterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicFooterData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredRegions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"6"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicFooterDataQuery, PublicFooterDataQueryVariables>;
export const StripeInformationModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripeInformationModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_information"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amount_charged"}},{"kind":"Field","name":{"kind":"Name","value":"amount_received"}},{"kind":"Field","name":{"kind":"Name","value":"card_brand"}},{"kind":"Field","name":{"kind":"Name","value":"charge_currency"}},{"kind":"Field","name":{"kind":"Name","value":"receive_currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_type"}},{"kind":"Field","name":{"kind":"Name","value":"due_date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"servicePaymentParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"servicePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trip_schedule_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StripeInformationModalQuery, StripeInformationModalQueryVariables>;
export const DashboardInboxPropertyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardInboxPropertyQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceDetails"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyPriceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyFiltersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minimum_stay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceDetails"}}}]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calendar_source"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardInboxPropertyQueryQuery, DashboardInboxPropertyQueryQueryVariables>;
export const UpdatePropertyCommissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePropertyCommission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commission_percentage"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyCommissionMutation, UpdatePropertyCommissionMutationVariables>;
export const UpdatePropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const TripScheduleServiceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tripScheduleServiceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request_id"}},{"kind":"Field","name":{"kind":"Name","value":"survey_id"}},{"kind":"Field","name":{"kind":"Name","value":"trip_service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<TripScheduleServiceRequestQuery, TripScheduleServiceRequestQueryVariables>;
export const UserDropdownBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDropdownBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFiltersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"single_line"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_channel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}}]} as unknown as DocumentNode<UserDropdownBookingQuery, UserDropdownBookingQueryVariables>;
export const AvailabilityUpdateBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailabilityUpdateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"departure"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"security_deposit"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<AvailabilityUpdateBookingQuery, AvailabilityUpdateBookingQueryVariables>;
export const BookingConfirmationViaBankTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingConfirmationViaBankTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"booking_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingConfirmationPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"booking_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"booking_token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_type"}}]}}]}}]}}]} as unknown as DocumentNode<BookingConfirmationViaBankTransferQuery, BookingConfirmationViaBankTransferQueryVariables>;
export const ConfirmPaymentGroupViaBankTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"confirmPaymentGroupViaBankTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPaymentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ConfirmPaymentGroupViaBankTransferMutation, ConfirmPaymentGroupViaBankTransferMutationVariables>;
export const MarkServicePaymentsPendingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markServicePaymentsPending"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markServicePaymentsPending"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MarkServicePaymentsPendingMutation, MarkServicePaymentsPendingMutationVariables>;
export const PropertyDropdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PropertyDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertiesOrderByClause"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyFiltersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}}]} as unknown as DocumentNode<PropertyDropdownQuery, PropertyDropdownQueryVariables>;
export const UserDropdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFiltersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}}]} as unknown as DocumentNode<UserDropdownQuery, UserDropdownQueryVariables>;
export const PropertyDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"propertyDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partnerTeamContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"calendar_source"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"single_line"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"main_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internal_notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pool_size"}},{"kind":"Field","name":{"kind":"Name","value":"pool_type"}},{"kind":"Field","name":{"kind":"Name","value":"pool_rules"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"possible_issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PropertyDetailsQuery, PropertyDetailsQueryVariables>;
export const PossibleIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PossibleIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"possibleIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PossibleIssuesQuery, PossibleIssuesQueryVariables>;
export const SendInquiryToPartnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendInquiryToPartner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendInquiryToPartnerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendInquiryToPartner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inquiryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inquiryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendInquiryToPartnerMutation, SendInquiryToPartnerMutationVariables>;
export const PropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Property"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PropertyQuery, PropertyQueryVariables>;
export const ServiceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServiceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request_id"}},{"kind":"Field","name":{"kind":"Name","value":"trip_service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"concierge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ServiceRequestQuery, ServiceRequestQueryVariables>;
export const GetSurveyBankInfoForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSurveyBankInfoForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyBankInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyBankInfoForAdminQuery, GetSurveyBankInfoForAdminQueryVariables>;
export const GetSurveyBankInfoForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSurveyBankInfoForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surveyBankInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]} as unknown as DocumentNode<GetSurveyBankInfoForUserQuery, GetSurveyBankInfoForUserQueryVariables>;
export const UpdateConfirmedBookingDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConfirmedBookingDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConfirmedBookingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfirmedBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateConfirmedBookingDatesMutation, UpdateConfirmedBookingDatesMutationVariables>;
export const UpdateConfirmedBookingPropertyAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdateConfirmedBookingPropertyAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"departure"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<UpdateConfirmedBookingPropertyAvailabilityQuery, UpdateConfirmedBookingPropertyAvailabilityQueryVariables>;
export const UpdateConfirmedBookingPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConfirmedBookingProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConfirmedBookingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfirmedBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateConfirmedBookingPropertyMutation, UpdateConfirmedBookingPropertyMutationVariables>;
export const UserDropdownMergeModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDropdownMergeModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFiltersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_verification_session_id"}},{"kind":"Field","name":{"kind":"Name","value":"booking_channel"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"single_line"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total_spent"}},{"kind":"Field","name":{"kind":"Name","value":"credit"}},{"kind":"Field","name":{"kind":"Name","value":"membership_type"}},{"kind":"Field","name":{"kind":"Name","value":"login_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"google"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passport_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries_specific"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiries_general"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"service_requests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}}]}}]}}]}}]} as unknown as DocumentNode<UserDropdownMergeModalQuery, UserDropdownMergeModalQueryVariables>;
export const MergeUserAccountsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergeUserAccountsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergeUserAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergeUserAccountsMutation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MergeUserAccountsMutationMutation, MergeUserAccountsMutationMutationVariables>;
export const DuplicatePropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"duplicateProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DuplicatePropertyMutation, DuplicatePropertyMutationVariables>;
export const SyncPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportPropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SyncPropertyMutation, SyncPropertyMutationVariables>;
export const DownloadPropertyBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"downloadPropertyBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isB2b"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadPropertyBrochure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"isB2b"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isB2b"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<DownloadPropertyBrochureMutation, DownloadPropertyBrochureMutationVariables>;
export const SendForApprovalFromTripScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendForApprovalFromTripSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripScheduleSendForApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"approval_sent_at"}}]}}]}}]} as unknown as DocumentNode<SendForApprovalFromTripScheduleMutation, SendForApprovalFromTripScheduleMutationVariables>;
export const DownloadServiceRequestPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"downloadServiceRequestPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadServiceRequestPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<DownloadServiceRequestPdfMutation, DownloadServiceRequestPdfMutationVariables>;
export const ServiceTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServiceTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"service_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceTemplatesQuery, ServiceTemplatesQueryVariables>;
export const DestinationSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DestinationSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"regionsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RegionsFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subRegionsFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubRegionsFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"citiesFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CitiesFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"regionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subRegions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subRegionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citiesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"subRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DestinationSearchResultsQuery, DestinationSearchResultsQueryVariables>;
export const UseTripScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseTripSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripScheduleGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_generated"}},{"kind":"Field","name":{"kind":"Name","value":"commission_amount"}},{"kind":"Field","name":{"kind":"Name","value":"commission_included"}},{"kind":"Field","name":{"kind":"Name","value":"commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"partner_price"}},{"kind":"Field","name":{"kind":"Name","value":"service_fee"}},{"kind":"Field","name":{"kind":"Name","value":"service_fee_application"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"}}]}}]}}]}}]} as unknown as DocumentNode<UseTripScheduleQuery, UseTripScheduleQueryVariables>;
export const CurrentUserIdentityVerifiedAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserIdentityVerifiedAt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identity_verified_at"}},{"kind":"Field","name":{"kind":"Name","value":"passport_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserIdentityVerifiedAtQuery, CurrentUserIdentityVerifiedAtQueryVariables>;
export const GetVerificationSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVerificationSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetVerificationSessionQuery, GetVerificationSessionQueryVariables>;
export const UseAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"arrival"}},{"kind":"Field","name":{"kind":"Name","value":"departure"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<UseAvailabilityQuery, UseAvailabilityQueryVariables>;
export const ExternalPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalPropertiesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"provider_last_synced_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}}]}}]}}]}}]} as unknown as DocumentNode<ExternalPropertiesQuery, ExternalPropertiesQueryVariables>;
export const BookingConfirmationViaCardPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingConfirmationViaCardPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"booking_token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingConfirmationPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"booking_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"booking_token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"session_id"}},{"kind":"Field","name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}}]}}]}}]} as unknown as DocumentNode<BookingConfirmationViaCardPaymentQuery, BookingConfirmationViaCardPaymentQueryVariables>;
export const PaymentGroupViaCardPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentGroupViaCardPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"session_id"}},{"kind":"Field","name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}}]}}]}}]} as unknown as DocumentNode<PaymentGroupViaCardPaymentQuery, PaymentGroupViaCardPaymentQueryVariables>;
export const PaymentGroupViaBankTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentGroupViaBankTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_group_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_group_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment_type"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentGroupViaBankTransferQuery, PaymentGroupViaBankTransferQueryVariables>;
export const TripSchedulePaymentViaCardPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TripSchedulePaymentViaCardPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripSchedulePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_secret"}}]}}]}}]} as unknown as DocumentNode<TripSchedulePaymentViaCardPaymentQuery, TripSchedulePaymentViaCardPaymentQueryVariables>;
export const TripSchedulePaymentViaBankTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TripSchedulePaymentViaBankTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tripSchedulePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"}}]}}]}}]}}]} as unknown as DocumentNode<TripSchedulePaymentViaBankTransferQuery, TripSchedulePaymentViaBankTransferQueryVariables>;
export const ValidateBoatCharterSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateBoatCharterSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoatCharterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateBoatCharterSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ValidateBoatCharterSlideMutation, ValidateBoatCharterSlideMutationVariables>;
export const CreateBoatCharterSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBoatCharterSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BoatCharterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBoatCharterSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateBoatCharterSlideMutation, CreateBoatCharterSlideMutationVariables>;
export const ValidateCarRentalSurveySlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateCarRentalSurveySlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CarRentalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateCarRentalSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ValidateCarRentalSurveySlideMutation, ValidateCarRentalSurveySlideMutationVariables>;
export const CreateCarRentalSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCarRentalSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CarRentalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCarRentalSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateCarRentalSurveyMutation, CreateCarRentalSurveyMutationVariables>;
export const ValidatePreStockingSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validatePreStockingSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreStockingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatePreStockingSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ValidatePreStockingSlideMutation, ValidatePreStockingSlideMutationVariables>;
export const CreatePreStockingSlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPreStockingSlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreStockingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPreStockingSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreatePreStockingSlideMutation, CreatePreStockingSlideMutationVariables>;
export const ValidatePrivateChefSurveySlideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validatePrivateChefSurveySlide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrivateChefInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatePrivateChefSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ValidatePrivateChefSurveySlideMutation, ValidatePrivateChefSurveySlideMutationVariables>;
export const CreatePrivateChefSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPrivateChefSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrivateChefInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPrivateChefSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreatePrivateChefSurveyMutation, CreatePrivateChefSurveyMutationVariables>;